import URL, { strictEncode } from '../helper';
import axiosCall from './interceptor';

export const uploadDataSet = async (id, payload) => {
  const url = `${URL.BASE_URL}live/uploadDataSet?channel=print`;
  let response = await axiosCall('post', url, payload, true, false);
  return response.data;
};

export const uploadDataSetTransaction = async (name, payload,synchronous, channelType) => {
  const channelParam = channelType ? 'channelType=print' : 'channel=print';
  const url = `${URL.TRANSACTION_SYSTEM_URL}live/uploadDataSet?batchName=${strictEncode(name)}&${channelParam}&synchronous=${synchronous}`;
  let response = await axiosCall('post', url, payload, true, false);
  return response.data;
};

export const uploadEnvDataSet = async (env, payload, batchName='', channelType) => {
  let url;
  if(batchName !== ''){
    url = `${URL.TRANSACTION_SYSTEM_URL}${env}/uploadDataSet?batchName=${strictEncode(batchName)}`;
  }
  else{
    url = `${URL.TRANSACTION_SYSTEM_URL}${env}/uploadDataSet`;
  }
  if (channelType) {
    const separator = url.includes('?') ? '&' : '?';
    url += `${separator}channelType=multiChannel`;
  }
  let response = await axiosCall('post', url, payload, true, false);
  return response.data;
};

export const staticDownload = async (payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}downloadZip`;
  const response = await axiosCall('post', url, payload, true, false, true);
  return response;
}

export const initiateTransaction = async (payload, isShortMessage = false) => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}communication/correspondence`;
  if(isShortMessage) {
    url = `${URL.BASE_URL}communication/correspondence`;
  }
  const response = await axiosCall('post', url, payload, undefined, undefined, true); 
  return response;
}

export const getCommunicationLanguages = async communicationId => {
  const url = `${URL.DESIGN_SYSTEM_URL}channel/${communicationId}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getDocumentsByCommunication = async (qaStatus, payload) => {
  const searchParam = new URLSearchParams(payload);
  let url = `${URL.DESIGN_SYSTEM_URL}channel/communication/document?${searchParam.toString()}`;
  if (qaStatus) {
    url = `${URL.TRANSACTION_SYSTEM_URL}qaCommunication/document?${searchParam.toString()}`;
  }
  const response = await axiosCall('get', url);
  return response.data;
};

export const getTemplateCount = async (resourceType = 'document', type) => {
  let url = `${URL.DESIGN_SYSTEM_URL}channel/document/count?type=${type}`;
  if (resourceType && resourceType !== 'document') {
    url = `${URL.DESIGN_SYSTEM_URL}standalone/${resourceType}/count?type=${type}`;
  }
  const response = await axiosCall('get', url);
  return response.data;
};

export const changeTemplateCategory = async (type, payload) => {
  const searchParam = new URLSearchParams(payload);
  const url = `${URL.TRANSACTION_SYSTEM_URL}category/${type}?${searchParam.toString()}`;
  const response = await axiosCall('patch', url);
  return response.data;
};
